export enum RouterBrand {
  CISCO = "CISCO",
  OMADA = "OMADA",
  RELEAD_OS = "RELEAD_OS",
  CISCO_CATALYST = "CISCO_CATALYST",
  FORTIGATE = "FORTIGATE",
}

export interface RouterBrandMetadata {
  name: string;
  icon: string;
  /** Whether the brand's captive portal integration can authenticate through RADIUS. */
  supportsRadius: boolean;
}

export const RouterBrandEnum: Record<RouterBrand, RouterBrandMetadata> = {
  [RouterBrand.CISCO]: {
    name: "Cisco meraki",
    icon: "assets/identity/cisco-icon.svg",
    supportsRadius: false,
  },
  [RouterBrand.OMADA]: {
    name: "Omada",
    icon: "assets/identity/omada.svg",
    supportsRadius: true,
  },
  [RouterBrand.RELEAD_OS]: {
    name: "ReleadOS",
    icon: "assets/identity/releadOS-icon.svg",
    supportsRadius: false,
  },
  [RouterBrand.CISCO_CATALYST]: {
    name: "Cisco catalyst",
    icon: "assets/identity/cisco-icon.svg",
    supportsRadius: false,
  },
  [RouterBrand.FORTIGATE]: {
    name: "Fortigate",
    icon: "assets/identity/fortinet-icon.svg",
    supportsRadius: true,
  },
};

export function isRadiusSupportedBrand(
  routerBrand: RouterBrand | null | undefined
): boolean {
  return !!routerBrand && !!RouterBrandEnum[routerBrand]?.supportsRadius;
}

export interface RouterBrandInterface {
  id: RouterBrand;
  value: string;
  icon: string;
}
